module.exports = __webpack_public_path__ + "assets/img/submit.d2b7af6b.png";